export const serverCreationSteps = {
  choosePlan: {
    label: 'Plan',
    next: 'chooseRegion',
    prev: null,
    nextButtonText: 'mycountly.server-creation.choose-plan-next',
    prefix: 'Basics',
    segment: 'Plan',
  },
  chooseRegion: {
    label: 'Configuration',
    next: 'coreFeatures',
    prev: 'choosePlan',
    nextButtonText: 'mycountly.server-creation.choose-region-next',
    prefix: 'Basics',
    segment: 'Region',
  },
  coreFeatures: {
    label: "What's included",
    next: 'chooseAddOns',
    prev: 'chooseRegion',
    nextButtonText: 'mycountly.server-creation.core-features-next',
    prefix: 'Features',
    segment: 'Plan',
  },
  chooseAddOns: {
    label: 'Advanced capabilities',
    next: 'chooseExtras',
    prev: 'coreFeatures',
    nextButtonText: 'mycountly.server-creation.choose-add-ons-next',
    prefix: 'Features',
    segment: 'Features Add-Ons',
  },
  chooseExtras: {
    label: 'Extras',
    next: 'paymentDetails',
    prev: 'chooseAddOns',
    nextButtonText: 'mycountly.server-creation.choose-extras-next',
    prefix: 'Extras',
    segment: 'Extras',
  },
  paymentDetails: {
    label: 'Complete setup',
    next: 'serverCreated',
    prev: 'chooseExtras',
    hideNext: true,
    nextButtonText: '',
  },
  serverCreated: {
    prev: null,
    next: null,
    hideFooter: true,
    nextButtonText: '',
  },
  preloginChoosePlan: {
    label: 'Plan',
    next: 'preloginChooseRegion',
    prev: null,
    nextButtonText: 'mycountly.server-creation.choose-plan-next',
    prefix: 'Basics',
    segment: 'Plan',
  },
  preloginChooseRegion: {
    label: 'Configuration',
    next: 'preloginCoreFeatures',
    prev: 'preloginChoosePlan',
    nextButtonText: 'mycountly.server-creation.choose-region-next-prelogin',
    prefix: 'Basics',
    segment: 'Region',
  },
  preloginCoreFeatures: {
    label: "What's included",
    next: 'preloginChooseAddOns',
    prev: 'preloginChooseRegion',
    nextButtonText: 'mycountly.server-creation.core-features-next',
    prefix: 'Features',
    segment: 'Plan',
  },
  preloginChooseAddOns: {
    label: 'Advanced capabilities',
    next: 'preloginChooseExtras',
    prev: 'preloginCoreFeatures',
    nextButtonText: 'mycountly.server-creation.choose-add-ons-next',
    prefix: 'Features',
    segment: 'Features Add-Ons',
  },
  preloginChooseExtras: {
    label: 'Extras',
    next: 'preloginRegister',
    prev: 'preloginChooseAddOns',
    nextButtonText: 'mycountly.server-creation.choose-extras-next',
    prefix: 'Extras',
    segment: 'Extras',
  },
  preloginRegister: {
    next: null,
    prev: 'preloginChooseExtras',
    nextButtonText: 'mycountly.server-creation.complete-setup-next',
    hideFooter: true,
  },
};
